import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { SupplierTypeEnum } from '../enums/supplier-type.enum';

/**
 * Create supplier DTO
 */
export class CreateSupplierDto {
  color?: string | null;
  notes?: string | null;
  type!: SupplierTypeEnum;
  tags?: TagDto[] | null;
  policies?: PolicyAssignDto[] | null;
  contact!: TenantContactDto;
  files?: FileDto[] | null;
}
